import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WhiteLabelBrand } from '@vlabs/monokit/shared/ui/white-label-brand';
import { useSelector } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { selectIsAuthenticated } from '@vlapps/luna/src/features/auth/selectors';

import ScrollToTop from '@vlapps/luna/src/components/scroll-to-top/ScrollToTop';
import { LoginPage } from '@vlapps/luna/src/features/auth/LoginPage';

import { LunaNavbar } from './navigation';
import Routes from './router';
import { routes } from './routes';
import { AuthTokenPage } from '../pages/auth-token/AuthTokenPage';

const queryClient = new QueryClient();
function LunaApp(): React.JSX.Element {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <BrowserRouter basename={import.meta.env.VITE_PUBLIC_URL}>
      <div style={{ display: 'flex', minHeight: '100svh' }}>
        <ScrollToTop />
        {!isAuthenticated && (
          <Switch>
            <Route
              component={AuthTokenPage}
              path={routes.auth.token}
            />
            <Route
              path="*"
              render={(props) => (
                <LoginPage
                  {...props}
                  CustomBrand={<WhiteLabelBrand style={{ backgroundPosition: 'center' }} />}
                />
              )}
            />
          </Switch>
        )}
        {!!isAuthenticated && (
          <React.Fragment>
            <LunaNavbar />
            <QueryClientProvider client={queryClient}>
              <Routes />
            </QueryClientProvider>
          </React.Fragment>
        )}
      </div>
    </BrowserRouter>
  );
}

export { LunaApp };
